export const DummyData = [

    {
         id: 1,
        type : "Personal",
        year : [{id: 1, cat : 'This year'}, { id: 2, cat:'Last year'}],
        number:  20,
        rate: +23,
        progressType: "positive"
    },

    {
        id: 2,
       type : "Business",
       year : [{id: 1,cat : 'This week'}, {id: 2,cat:'Last week'}],
       number:  80,
       rate: +3,
       progressType: "positive"
   },

   {
    id: 3,
   type : "Investors",
   year :[ {id: 1,cat : 'Today'}, {id: 2,cat:'Yesterday'}],
   number:  19,
   rate: +0.1,
   progressType: "negative"
},
]

export const orderChartsData = [

    {
         id: 1,
        type : "Total orders",
        year : [{id: 1, cat : 'This year'}, { id: 2, cat:'Last year'}],
        number:  5000000,
        rate: +23,
        progressType: "positive"
    },

    {
        id: 2,
       type : "Successful orders",
       year : [{id: 1,cat : 'This week'}, {id: 2,cat:'Last week'}],
       number:  2000000,
       rate: +3,
       progressType: "positive"
   },

   {
    id: 3,
   type : "Returned",
   year :[ {id: 1,cat : 'Today'}, {id: 2,cat:'Yesterday'}],
   number:  300000,
   rate: +0.1,
   progressType: "negative"
},
]

export const UsersType = [
    {
        id: 1,
        type: ['Profiled User', 'Non-profiled User'],
        amount : [6,2],
        color: ['#0091BF', '#BAD8D4'],
        data: {
            labels: [],
            datasets: [
                {
                    label: 'My First Dataset',
                    data:  [6,2],
                    backgroundColor: ['#0091BF', '#BAD8D4'],
                },
            ],
        }
       
    },

    {

        id: 2,
        type: ['User-per-Time', 'Total users'],
        amount : [3.5, 3.5],
        color: ['#8CB68B', '#004A8E'],
        data: {
            labels: [],
            datasets: [
                {
                    label: 'My Second Dataset',
                    data: [3.5, 3.5],
                    backgroundColor: ['#8CB68B', '#004A8E'],
                },
            ],
        }
    },

   

]



